import React from 'react';
import { Dialog, IconButton, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CoupleQuestsImage from '../../../utilities/images/CoupleQuests/coupleQuests.png';
import CoupleQuestDialogImage1 from '../../../utilities/images/CoupleQuests/CoupleQuestDialog1.png';
import CoupleQuestDialogImage2 from '../../../utilities/images/CoupleQuests/CoupleQuestDialog2.png';
import CoupleQuestDialogImage3 from '../../../utilities/images/CoupleQuests/CoupleQuestDialog3.png';
import CoupleQuestDialogImage4 from '../../../utilities/images/CoupleQuests/CoupleQuestDialog4.png';
import CoupleQuestDialogImage5 from '../../../utilities/images/CoupleQuests/CoupleQuestDialog5.png';
import CoupleQuestDialogImage6 from '../../../utilities/images/CoupleQuests/CoupleQuestDialog6.png';
import ImageCarousel from './ImageCarousel';
import './Projects.css';
import { t } from 'i18next';
import SlideUpTransition from '../SlideUpTransition';
import ProjectActionButtons from './ProjectActionButtons';

interface CoupleQuestsDialogProps {
    open: boolean;
    onClose: () => void;
}

const CoupleQuestsDialog: React.FC<CoupleQuestsDialogProps> = ({ open, onClose }) => {
    const isCompactScreen = useMediaQuery('(max-width: 768px)');

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={isCompactScreen}
            TransitionComponent={SlideUpTransition}
            sx={{
                '& .MuiDialog-paper': {
                    margin: isCompactScreen ? 0 : 2,
                    width: isCompactScreen ? '100vw' : 'auto',
                    maxWidth: isCompactScreen ? '100vw' : 'min(92vw, 960px)',
                    maxHeight: isCompactScreen ? '100dvh' : '95dvh',
                    borderRadius: isCompactScreen ? 0 : 3,
                    overflow: isCompactScreen ? 'auto' : 'hidden',
                },
            }}
        >
            <div className="card">
                <IconButton aria-label="Close dialog" onClick={onClose} className="dialog-close-button" size="small">
                    <CloseIcon fontSize="small" />
                </IconButton>
                
                <div className="title">{t("projectDialogs.CoupleQuests.title")}</div>
                
                <div className="card-content">
                    <ImageCarousel
                        images={[
                            CoupleQuestsImage,
                            CoupleQuestDialogImage1,
                            CoupleQuestDialogImage2,
                            CoupleQuestDialogImage3,
                            CoupleQuestDialogImage4,
                            CoupleQuestDialogImage5,
                            CoupleQuestDialogImage6,
                        ]}
                        alt={t("projectDialogs.CoupleQuests.title")}
                    />
                    
                    <div className="description">
                        <div className="left-box">
                            {t("projectDialogs.CoupleQuests.description")}
                        </div>
                        
                        <div className="right-box">
                            <div>Flutter</div>
                            <div>Dart</div>
                            <div>Material UI</div>
                            <div>Firebase</div>
                            <div>Android</div>
                        </div>
                    </div>
                </div>
                
                <ProjectActionButtons
                    googlePlayUrl="https://play.google.com/store/apps/details?id=com.yourdomain.CoupleQuests"
                    websiteUrl="https://CoupleQuests-69c04.web.app"
                />
            </div>
        </Dialog>
    );
};

export default CoupleQuestsDialog;